import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@marvelapp/ui';
export default function TooltipWrap({ children, content, showTooltip }) {
    if (showTooltip) {
        return (_jsx("div", { "data-testid": "tooltip-wrap", children: _jsx(Tooltip, { content: content, cursor: "default", whiteSpace: "wrap", width: 180, children: children }) }));
    }
    return children;
}
